var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgAccommodation = function SvgVaknlLgAccommodation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D9B8B",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeWidth: 1.5,
    d: "M9 14h4v19H9zm18 0h4v19h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    d: "M18 14h4m-4 3.333h4m-4 3.334h4M18 24h4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#288374",
    strokeWidth: 1.5,
    d: "M11.75 14v19m16.5-19v19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeWidth: 1.5,
    d: "M9 14h4v19H9zm18 0h4v19h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    d: "M14.137 34V11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeWidth: 1.5,
    d: "M13 10h14v24H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeWidth: 1.5,
    d: "M18 28h4v6h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3AD05",
    fillRule: "nonzero",
    stroke: "#FFF",
    d: "m20 11.5-1.666 1.133a.673.673 0 0 1-1.034-.739L17.887 10l-1.618-1.2a.659.659 0 0 1 .4-1.189l2.029-.04.662-1.871a.684.684 0 0 1 1.28 0l.666 1.873 2.029.04a.658.658 0 0 1 .63.45.657.657 0 0 1-.23.739L22.113 10l.588 1.9a.673.673 0 0 1-1.035.735L20 11.5z"
  }))));
};
export default SvgVaknlLgAccommodation;